import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import useGet from "./useGet";
import useUpdate from "./useUpdate";
import { EditActionContext } from "./EditActionContext";
import BeelditForm from "@beeldit/core/components/BeelditForm";
import BeelditGenericForm from "@beeldit/core/components/BeelditGenericForm";

function useEditAction(modelConfig: any, index: any, modalSize?: string, formFilterValues?: any): any {
  const get = useGet(modelConfig);
  const getFunction = (id: number) => get(id);

  /**
   * Form store success function definition
   */
  const onSuccessUpdate = () => {
    setShowModal(false);
    index(); // We pass the function to refresh the table on success
  };

  const update = useUpdate(modelConfig);
  const updateFunction = () => update(onSuccessUpdate);

  /** Creation and edition modal function and state definition */
  const contextInstance = useContext(EditActionContext);
  const { showModal, setShowModal } = contextInstance;

  /** Creation and edition modal element definition */
  const { element } = useContext(EditActionContext);

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: "Edit " + modelConfig.modelName,
    contextInstance: contextInstance,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(), //We pass the function for the submit of the modal
    fullscreen: modelConfig.modalFullScreen,
    size: modalSize,
  };

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      updateFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    contextInstance: contextInstance,
    filterData: formFilterValues, // We pass the filters to the form
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <BeelditGenericForm formConfig={formConfig} modelConfig={modelConfig}/>
    </CrudModuleFactoryModal>
  );

  /** END EDIT FORM ACTION */

  return {
    getFunction,
    actionTemplate,
    showModal
  };
}

export default useEditAction;
